import { connect } from "react-redux";
import RequestView from "./requestView";
import { bindActionCreators } from "redux";
// import {viewRequest, approvalAction} from "../../../services/redux/Wallet/action";
import {walletFinanceRequest,requestApprovalList,viewRequest} from "../../../services/redux/Wallet/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
const mapStateToProps = (state) => ({
    showData : state.Wallet.requestById,
    approvalListDetails : state.Wallet.approvlListData,
    walletfinancerequestDetails : state.Wallet.walletfinancerequest,
    requestedAction : state.Wallet.requestedAction,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletFinanceRequest,
        requestApprovalList,
        viewRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RequestView);